export default (productName) => {
  if (typeof productName !== 'string') return false;

  const unavailableProducts =
    /(TAB - Bank Statement Conventional - 2-year|Paycheck Protection|Sunflower Marketplace)/i;

  return unavailableProducts.test(productName);
};
